import { Row, Col, Drawer } from "antd";
// import Lottie from "lottie-react";
// import loading from "../../assets/assets/json/loading.json";
import "./loading.css";
import logo from "../../assets/images/logo.png";

const Loading = (props) => {
  const { enableLoading } = props;
  return (
    <Drawer
      className="background-transparent"
      visible={enableLoading}
      closable={false}
      placement="top"
      width="100%"
      height="100%"
      size="large"
    >
      <div
        style={{
          width: "240px",
          height: "240px",
          background: "#ffffff",
          borderRadius: "50%",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          margin: "auto",
        }}
      >
        <Row justify={"center"}>
          <Col>
            <img
              src={logo}
              style={{
                width: "95%",
                marginTop: "25%",
              }}
              alt="Loading..."
            />
          </Col>
        </Row>
      </div>

      {/* <div className="loading-div"> */}
      {/* <img
          src={logo}
          style={{
            height: "50px",
            // width: "100%",
          }}
          alt="Logo"
        /> */}
      {/* <Lottie animationData={loading} style={{ marginTop: "-10px" }} /> */}
      {/* </div> */}
    </Drawer>
  );
};
export default Loading;
